import { KrCard } from '@/common/card/KrCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { useChatbotRegistration } from '../ai/ChatbotMgrContext';

/**
 *
 * The core dashboard card component that registers itself to the Chatbot.
 */
export const DashboardCard = ({ title, description, module, plugin, reqParam, children, ...krCardProps }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    rsrc.data(module, plugin, reqParam).then((res) => {
      setData(res);
    });
  }, [reqParam]);

  useChatbotRegistration(title, description, { data: { module, plugin, reqParam } });

  if (!data) return null;

  return (
    <KrCard title={title} {...krCardProps}>
      {children(data)}
    </KrCard>
  );
};
